import { render } from "./BountyDetailView.vue?vue&type=template&id=78044692&scoped=true&ts=true"
import script from "./BountyDetailView.vue?vue&type=script&lang=ts"
export * from "./BountyDetailView.vue?vue&type=script&lang=ts"

import "./BountyDetailView.vue?vue&type=style&index=0&id=78044692&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78044692"]])

export default __exports__